import axios from 'axios';

export default function (context, {cb}) {
  context.commit('clean');
  context.commit('events/clean');
  context.commit('permit/clean');
  context.commit('setting/clean');
  context.commit('loading', true);
  axios({
    method: 'GET',
    url: '/tourclient/account/currentUser?withPartner=true&_=' + new Date().getTime(),
  }).then(({data}) => {
    context.commit('set', data);
    context.commit('loading', false);
    if (context.state.auth) {
      if (window.yaCounter16750657) {
        window.yaCounter16750657.setUserID(data.PartnerId);
        window.yaCounter16750657.userParams({
          Department: data.Department.toString().slice(0, 50),
          FullName: data.FullName.toString().slice(0, 50),
          Login: data.Login.toString().slice(0, 50),
          PartnerId: data.PartnerId.toString().slice(0, 50),
        });
      }
      context.dispatch('permit/get', {
        cb(){
          if (window.HelpAdd && context.getters.permit(309)) window.HelpAdd(data.PartnerId);
          if (window.AddNews) window.AddNews(data.PartnerId);
        }
      });
      context.dispatch('setting/get', {});
      context.dispatch('events/get', {});
      context.dispatch('wiki/get', {});
    } else {
      if (cb) cb(context.state);
      if (DEV) {
        return;
      }
      window.location.href = '/tourclient/login.html?ret=' + encodeURIComponent(window.location.href);
    }
  }).catch(data => {
    context.commit('loading', false);
    context.dispatch('error', data, {root: true});
  });
}
